<template>
  <div>
    <div style="text-align: center">
      <h4 class="titulo-component">Lista de Inscritos na Pré-matrícula Online</h4>
      <span >atualizado em {{ new Date().toLocaleDateString() }}</span>
    </div>
    <el-row :gutter="10" class="u-mt-20 u-mb-20 filtros-lista">      
        <el-col :xs="24" :sm="12" :md="12">
          <el-select
            @change="selecionaInstituicao()"
            v-model="filtro.instituicao_id"
            filterable
            placeholder="Pesquisar Instituição"
            clearable
          >
            <el-option
              v-for="(item, i) in instituicoes"
              :key="i"
              :label="item.nome"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="8" :md="8">
          <el-input
            v-model="filtro.nome"
            placeholder="Pesquisar por nome"
            @keyup.native.enter="changeNome()"
          ></el-input>
        </el-col>
        <el-col :xs="24" :sm="4" :md="4">
          <el-select
            clearable
            placeholder="Modalidade"
            no-data-text="Selecione a modalidade"
            v-model="filtro.modalidade"
            @change="changeFiltros()"
          >
            <el-option :key="1" label="Infantil 02 anos" value="2"></el-option>
            <el-option :key="2" label="Infantil 03 anos" value="3"></el-option>
            <el-option :key="3" label="Infantil 04 anos" value="4"></el-option>
            <el-option :key="4" label="Infantil 05 anos" value="5"></el-option>

            <el-option :key="5" label="1º ano" value="6"></el-option>
            <el-option :key="6" label="2º ano" value="7"></el-option>
            <el-option :key="7" label="3º ano" value="8"></el-option>
            <el-option :key="8" label="4º ano" value="9"></el-option>
            <el-option :key="9" label="5º ano" value="10"></el-option>
            <el-option :key="10" label="6º ano" value="11"></el-option>
            <el-option :key="11" label="7º ano" value="12"></el-option>
            <el-option :key="12" label="8º ano" value="13"></el-option>
            <el-option :key="13" label="9º ano" value="14"></el-option>

            <el-option :key="14" label="Eja - 1º Ano" value="30"></el-option>
            <el-option
              :key="15"
              label="Eja - 2º e 3º Anos"
              value="31"
            ></el-option>
            <el-option
              :key="16"
              label="Eja - 4º e 5º Anos"
              value="32"
            ></el-option>
            <el-option
              :key="17"
              label="Eja - 6º e 7º Anos"
              value="33"
            ></el-option>
            <el-option
              :key="18"
              label="Eja - 8º e 9º Anos"
              value="34"
            ></el-option>
          </el-select>
        </el-col>
      
    </el-row>
    <el-row :gutter="10" class="u-mt-20 u-mb-30 filtros-lista u-text-center">
      <el-col :xs="8" :sm="8" :md="8">
        <label>Matriculados</label>
        <el-input 
          v-model="matriculas"
          readonly                                 
        ></el-input>
      </el-col>
      <el-col :xs="8" :sm="8" :md="8">
        <label name="vagas">Vagas Disponíveis</label>
        <el-input
          v-model="vagas" 
          readonly                    
        ></el-input>
      </el-col>
      <el-col :xs="8" :sm="8" :md="8">
        <label name="espera">Aguardando Vaga</label>
        <el-input
          v-model="espera" 
          readonly                                
        ></el-input>
      </el-col>   
    </el-row>

    <div class="container-table scroll">
      <table class="table table-striped u-fs-16">
        <thead>
          <tr>
            <th class="hidden-mobile">Ordem</th>
            <th>Aluno</th>
            <th>Data de Nascimento</th>
            <th>Responsável</th>
            <th class="hidden-mobile">Cod. Inscrição</th>
            <th class="hidden-mobile">Situação</th>
            <th class="hidden-mobile">Data da Inscrição</th>
          </tr>
        </thead>
        <tbody v-if="statusList">
          <tr v-for="(item, i) in items" :key="item.id">
            <td class="hidden-mobile">
              {{ (i + 1) }}
            </td>
            <td>{{ item.nome.slice(0, 5) + '************' + item.nome.slice(-4) }}</td>
            <td>{{ $moment(item.data_nascimento).format("DD/MM/YYYY") }}</td>
            <td>{{ item.responsavel.slice(0, 5) + '************' + item.responsavel.slice(-4) }}</td>
            <td class="hidden-mobile">{{ item.codigo_inscricao.slice(0, 4) + '******' }}</td>
            <td class="u-lowercase hidden-mobile">
              <template v-if="item.idade_letiva <= 5">
                <span
                  v-if="!item.matricula_efetivada && item.cancelado"
                  style="color: #ff0000"
                  >CANCELADO</span
                >
                <span
                  v-if="
                    !item.matricula_efetivada &&
                    !item.cancelado &&
                    item.situacao_vaga
                  "
                  style="color: #857104"
                  >AGENDADO</span
                >
                <span
                  v-if="
                    !item.matricula_efetivada &&
                    !item.cancelado &&
                    !item.situacao_vaga
                  "
                  style="color: #857104"
                  >FILA DE ESPERA</span
                >
                <span
                  v-if="item.matricula_efetivada && !item.cancelado"
                  style="color: #038915"
                  >MATRICULADO</span
                >
              </template>
              <template v-else>
                <span
                  v-if="item.matricula_efetivada"
                  style="color: #038915"
                  >MATRICULADO</span
                >
                <span
                  v-if="!item.matricula_efetivada && item.cancelado"
                  style="color: #ff0000"
                  >CANCELADO</span
                >
                <span
                  v-if="!item.matricula_efetivada && !item.cancelado"
                  style="color: #857104"
                  >AGENDADO</span
                >
              </template>
            </td>
            <td class="hidden-mobile">{{ $moment(item.created_at).format('DD/MM/YYYY HH:mm:ss') }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="!statusList" class="u-text-center u-mt-25">
        <img src="/public/img/loading-bar.gif" />
      </div>
      <el-row :gutter="10" v-if="statusList">
        <el-col :xs="24" :sm="12" :md="12">
          <div class="u-text-left u-mt-10">            
            {{ paginate.qtdItens }} registros encontrados.
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    loadingButtonPdf: false,
    statusList: false,
    ref: [],
    instituicoesvagas: [],
    instituicoes: {},
    instituicoesmatriculas: {},
    filtro: {
      nome: "",
      instituicao_id: "",
      modalidade: "",
      data: "",
      situacao_vaga: "",
    },
    instituicao_id: "",
    paginate: {
      page: 1,
      qtdItens: null,
      from: "",
      to: "",
    },
    items: [],
    matriculas: 0,
    vagas: 0,
    espera: 0,
  }),
  mounted() {   
    this.buscaInstituicoes()
    if (this.instituicoes) {
      this.filtro.instituicao_id = this.instituicao_id;
    }

    this.loadingInscritos();
  },
  methods: {
    async buscaInstituicoes() {
      this.loadingInst = true;
      this.instituicao_id = "";

    await this.$axios
        .get(
          `${this.$store.state.config.baseUrlApi}/api/pre-matricula/getInstituicoes`,          
          this.$store.getters.getHeaderAuth
        )
        .then((response) => {         
          this.instituicoes = response.data;
          this.loadingInst = false;
        })
        .catch((error) => {
          this.$store.commit("throwException", error);
        }); 
        
    },
    selecionaInstituicao() {     
      this.instituicao_id = ""      
      this.instituicao_id = this.filtro.instituicao_id;           
      this.loadingInscritos(); 
      this.getVagas();
      this.getMatriculas();
    },
    changeNome() {
      this.filtro.idade = "";
      this.changeFiltros();
    },
    changeFiltros() {
      this.paginate.page = 1;
      this.loadingInscritos(); 
      this.getVagas()        
    },
    async loadingInscritos() {
      this.statusList = false;
      this.items = [];

      await this.$axios
        .post(
          `${this.$store.state.config.baseUrlApi}/api/pre-matricula/getAllInscritosNovatos`,
          this.filtro,
          this.$store.getters.getHeaderAuth
        )
        .then((response) => {

          this.items = response.data;
          this.paginate.qtdItens = response.data.length;
          this.paginate.from = response.data.from;
          this.paginate.to = response.data.to;
          this.statusList = true;     

          this.getEspera();    
          this.getMatriculados(); 
             
        })
        .catch((error) => {
          this.$store.commit("throwException", error);
        });

        this.getEspera();

    },    
    getPagePagination(page) {
      this.paginate.page = page;
      this.loadingInscritos();
    },
    getEspera(){
      this.espera = ""; 
      let count = 0;       
      
      this.items.forEach(item => {
        
        if (!item.matricula_efetivada && !item.cancelado && !item.situacao_vaga) {
                   
          count++;  
        }
        
      });

      this.espera = count;
      
    },
    async getVagas(){
      this.loadingInst = true;

      this.vagas = "";
      let contVagas = 0;

      await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/pre-matricula/getInstituicoesWithVagas/${this.filtro.modalidade}/${this.filtro.modalidade}`, this.$store.getters.getHeaderAuth).then(response => {
        
        this.instituicoesvagas = response.data;        

        this.loadingInst = false;

      }).catch((error) => { this.$store.commit('throwException', error); });
      

      for(let i in this.instituicoesvagas) {        
        if(this.instituicoesvagas[i].instituicao_id == this.instituicao_id) {          
          for (let j in this.instituicoesvagas[i].turnos) {            
            contVagas += this.instituicoesvagas[i].turnos[j].vagas;
          }
        }
      }

      this.vagas = contVagas;  
      
    },
    async getMatriculas(){
      this.loadingInst = true;
      
      let contMat = 0;

      await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/pre-matricula/getMatriculasInstituicoes`, this.$store.getters.getHeaderAuth).then(response => {
        
        this.instituicoesmatriculas = response.data;               

        this.loadingInst = false;

      }).catch((error) => { this.$store.commit('throwException', error); });

      for(let i in this.instituicoesmatriculas) {                
        if( i == this.instituicao_id) {                  
          contMat = this.instituicoesmatriculas[i].qtd_matriculados;
        }
      }

      this.matriculas = contMat;      
    }
  },

  components: {},
};
</script>
